import { Link } from '@tanstack/react-router';
import { BRAND, PILLARS } from '@pdf-ticket/shared';

export function IndexRoute() {
  return (
    <main
      style={{
        minHeight: '100dvh',
        display: 'grid',
        placeItems: 'center',
        background: 'oklch(98% 0 0)',
        color: 'oklch(18% 0 0)',
        fontFamily: 'system-ui, sans-serif',
        padding: '2rem',
      }}
    >
      <section style={{ maxWidth: '56rem', textAlign: 'center' }}>
        <h1 style={{ fontSize: 'clamp(2.5rem, 1rem + 5vw, 5rem)', margin: 0 }}>
          {BRAND.name}
        </h1>
        <p style={{ fontSize: '1.125rem', opacity: 0.75, marginTop: '0.5rem' }}>
          {BRAND.tagline}
        </p>
        <ul
          style={{
            listStyle: 'none',
            padding: 0,
            marginTop: '2rem',
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(11rem, 1fr))',
            gap: '0.75rem',
          }}
        >
          {PILLARS.map((p) => (
            <li
              key={p.id}
              style={{
                border: '1px solid oklch(90% 0 0)',
                borderRadius: '0.75rem',
                padding: '0.875rem 1rem',
                background: 'white',
                textAlign: 'left',
              }}
            >
              <strong style={{ display: 'block' }}>{p.label}</strong>
              <span style={{ fontSize: '0.8125rem', opacity: 0.7 }}>{p.detail}</span>
            </li>
          ))}
        </ul>
        <Link
          to="/edit"
          style={{
            display: 'inline-block',
            marginTop: '2rem',
            padding: '0.875rem 1.75rem',
            background: 'oklch(45% 0.18 250)',
            color: 'white',
            borderRadius: '0.625rem',
            textDecoration: 'none',
            fontWeight: 600,
          }}
        >
          エディタを開く →
        </Link>
      </section>
    </main>
  );
}
